//As client for dedicated employee we want to see the values in client's currency and convert them to this currency.
//As admin for dedicated employees we want to see the values which are set to the dedicated employee. 
export const getDedicatedEmployeeValue = (employeeValue) => {
    return Number(employeeValue).toFixed(2);
};
